import React from "react";
import {
  Container,
  TextField,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
import LogoHeader from "../../Shared/LogoHeader/LogoHeader";
import FieldLabel from "../../Shared/FieldLabel/FieldLabel";
import Toast from "../../Shared/Toast/Toast";

const LoginNative = (props: any) => {
  const {
    setEmail,
    errors,
    setPassword,
    logIn,
    loading,
    showErrorToast,
    closeErrorToast,
  } = props;

  return (
    <Container
    data-testid='login'>
      <LogoHeader />
      <Box sx={{
        fontWeight: '700',
        fontSize: '16px',
        lineHeight: '24px',
        textAlign: 'center',
        color: '#3C3B3B',
        marginTop: '100px',
        marginBottom: '50px'
      }}>
        Faça o login para começar uma vistoria
      </Box>
      <FieldLabel required htmlFor="login-email">E-mail</FieldLabel>
      <TextField
        error={!!errors.email}
        helperText={errors.email}
        fullWidth
        id="login-email"
        placeholder="usuario@email.com"
        variant="outlined"
        className="square-input"
        onChange={(e) => { setEmail(e.target.value) }}
        data-testid='email-input'
      />
      <FieldLabel required htmlFor="login-password">Senha</FieldLabel>
      <TextField
        error={!!errors.password}
        helperText={errors.password}
        fullWidth
        id="login-password"
        variant="outlined"
        className="square-input"
        placeholder="Digite sua senha"
        type="password"
        onChange={(e) => { setPassword(e.target.value) }}
        data-testid='password-input'
      />
      <Button
        fullWidth
        variant="contained"
        className="black-button"
        sx={{ marginTop: '30px' }}
        onClick={() => { logIn() }}
        disabled={loading}
        data-testid='submit-button'
      >Entrar</Button>
      {loading && (
        <Box
          component="div"
          data-testid='loading-box'
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: '30px'
          }}
        >
          <CircularProgress
            color="primary"
          />
        </Box>
      )}
      <Toast
        open={showErrorToast}
        onClose={closeErrorToast}
        message="Ocorreu um erro, tente novamente em instantes."
      />
    </Container>
  );
};

export default LoginNative;
